// src/utils/handleSubmit.js
const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);

  try {
    const response = await fetch("https://rkindustrialautomation.com/sendMail.php", {
      method: "POST",
      body: formData,
    });

    const result = await response.text();
    alert(result); // Show success or failure message
    form.reset();
  } catch (error) {
    alert("Something went wrong. Please try again later.");
    console.error("Email sending error:", error);
  }
};

export default handleSubmit;
